import { setImportPending, setImportError, setImportFinish } from "./actions";
import { getErrorMessage } from "../helpers/errorParser";
import { Observable } from "rxjs";
import { actionTypes } from "./actionTypes";
export const importEpic = importUrl => (action$, _, { ajax }) => {
    return action$.ofType(actionTypes.IMPORT).mergeMap(action => {
        const fd = new FormData();
        fd.append("file", action.payload.file);
        return ajax({
            url: importUrl(action.payload.config),
            method: "POST",
            body: fd
        })
            .map(() => setImportFinish(action.payload))
            .catch((error) => Observable.of(setImportError(action.payload, getErrorMessage(error))))
            .startWith(setImportPending(action.payload));
    });
};
//# sourceMappingURL=middleware.js.map